import { AlertTriangle, CheckCircle } from 'lucide-react';

import type { InstructorToastState } from './useInstructorToast';

interface InstructorToastProps {
  toast: InstructorToastState | null;
}

const InstructorToast = ({ toast }: InstructorToastProps) => {
  if (!toast) {
    return null;
  }

  return (
    <div
      aria-live="polite"
      className={`instructor-toast ${toast.variant}`}
      role="status"
    >
      {toast.variant === 'success' ? (
        <CheckCircle strokeWidth={2.6} />
      ) : (
        <AlertTriangle strokeWidth={2.6} />
      )}
      <span>{toast.message}</span>
    </div>
  );
};

export { InstructorToast };
